__turbopack_context__.v({
  "comparison-table": "_4lSMLq_comparison-table",
  "table": "_4lSMLq_table",
  "top-border-table": "_4lSMLq_top-border-table",
});
